import { render, staticRenderFns } from "./userEdit.vue?vue&type=template&id=53c66f0b&scoped=true&"
import script from "./userEdit.vue?vue&type=script&lang=js&"
export * from "./userEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c66f0b",
  null
  
)

export default component.exports